import React, { Component } from 'react';
import FormInput from '../Input/FormInput';

import './SwitcherButton.scss';

export default class SwitcherButton extends Component {
  render() {
    return (
      <div className="switch-btn" role="switcher">
        <span className="switch-btn__male">Male</span>
        <div className="switch-btn__gender">
          <FormInput
            type="radio"
            className="switch-btn__input"
            value="male"
            id="male"
            name="gender"
            defaultChecked={true}
          />
          <label htmlFor="male" className="switch-btn__label switch-btn__label-off" />
          <FormInput
            type="radio"
            className="switch-btn__input"
            value="female"
            id="female"
            name="gender"
            defaultChecked={false}
          />
          <label htmlFor="female" className="switch-btn__label switch-btn__label-on" />
          <span className="switch-btn__selection"></span>
        </div>
        <span className="switch-btn__female">Female</span>
      </div>
    );
  }
}
